import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const currencySlice = createSlice({
  name: "currencyDetails",
  initialState: [],
  reducers: {
    setCurrencyDetails: (_state: any, action: PayloadAction<any>) => ({
      ...action.payload,
    }),
  },
});

export const { setCurrencyDetails } = currencySlice.actions;

export const currencyDetails = currencySlice.reducer;

export default currencySlice.reducer;
